import { Result, Button, Layout } from "antd";
import { useNavigate } from "react-router-dom";
const { Content } = Layout;

export const Error403 = () => {
  const navigate = useNavigate();
  return (
    <Content>
      <Result
        status="403"
        title="403"
        subTitle="この機能の使用権限がありません。"
        extra={
          <Button
            size="large"
            type="primary"
            onClick={() => {
              navigate("/");
            }}
          >
            HOME画面に戻る
          </Button>
        }
      />
    </Content>
  );
};
